// // App.js
// import React, {useState } from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// // Import your new pages
// // import Implementation from "./TeamcenterPages/Implementation";
// // import MCADIntegration from "./TeamcenterPages/MCADIntegration";

// import Footer from './component/Home/footer/Footer';
// import Navbar from './component/Home/Navbar/Navbar';
// import HomePage from './pages/HomePage/HomePage';
// import ContactUsPage from './pages/ContactUsPage/ContactUsPage';
// import AboutUsPage from './pages/AboutusPage/AboutUsPage';
// import SolutionsPage from './component/PLMImplementation/BusinessProcessAndChangeManagement/SolutionsPage';
// import DocumentManagement from './component/PLMImplementation/DocumentManagement/DocumentManagement';
// import ProductBOM from './component/PLMImplementation/ProductBOMAndVariabilityManagement/ProductBOM';
// import ProgramAndProjectManagement from './component/PLMImplementation/ProgramAndProjectManagement/ProgramAndProjectManagement';
// import ReportingandAnalytics from './component/PLMImplementation/ReportingandAnalytics/ReportingandAnalytics';
// import TCIOnCloud from './component/PLMImplementation/TCImpementation-OnCloud/TCIOnCloud';
// import TCPerformance from './component/PLMImplementation/TCPerformanceTuning&HeathCheck-up/TCPerformance';
// import TeamCenterCyberSecurity from './component/PLMImplementation/TeamcenterCybersecurity/TeamCenterCyberSecurity';
// import TeamcenterCommunityCollaboration from './component/PLMImplementation/TeamcenterCommunityCollaboration/TeamcenterCommunityCollaboration';
// import TeamcenterImplementation from './component/PLMImplementation/TeamcenterImplementation/TeamcenterImplementation';
// import TeamcenterIntegrationforCAE from './component/PLMImplementation/TeamcenterIntegrationforCAE/TeamcenterIntegrationforCAE';
// import TeamcenterIntegrationforCAM from './component/PLMImplementation/TeamcenterIntegrationforCAM/TeamcenterIntegrationforCAM';
// import TeamcenterRAC from './component/PLMImplementation/TeamcenterRAC/TeamcenterRAC';
// import TeamcenterUpgradeMigration from './component/PLMImplementation/TeamcenterUpgrade&Migration/TeamcenterUpgradeMigration';
// import PLMERPDataAndProcessManagement from './component/PLMImplementation/PLM-ERPDataAndProcessManagement/PLMERPDataAndProcessManagement';
// import ManufacturingDataAndProcessManagement from './component/PLMImplementation/ManufacturingDataAndProcessManagement/ManufacturingDataAndProcessManagement';
// import LegacyPDM from './component/PLMImplementation/LegacyPDM/LegacyPDM';
// import ScrollToTop from './component/ScrollToTop/ScrollToTop';
// import SandipDalvi from './component/AboutUs/OurTeams/BoardMemberCard/SandipDalvi';
// import AkshayKothe from './component/AboutUs/OurTeams/BoardMemberCard/AkshayKothe';
// import NicolasMarais from './component/AboutUs/OurTeams/BoardMemberCard/NicolasMarais';
// import CareerPage from './pages/CareerPage/CareerPage';
// import MendixPage from './component/Solutions/Mendix/MendixPage';
// import StaffAugmentationPage from './component/Solutions/StaffAugmentation/StaffAugmentationPage';
// import PLMSolutionsAMCPage from './component/Solutions/PLMSolutionsAMC/PLMSolutionsAMCPage';
// import ECADIntegration from './component/PLMImplementation/ECADIntegration/ECADIntegration';
// import MCADIntegration from './component/PLMImplementation/MCADIntegration/MCADIntegration';
// import TeamCenterIntegrationCatia from './component/PLMImplementation/MCADIntegration/Integrations/TICatia/TeamCenterIntegrationCatia';
// import TIProEngineer from './component/PLMImplementation/MCADIntegration/Integrations/TIProEngineer/TIProEngineer';
// import TISolidworks from './component/PLMImplementation/MCADIntegration/Integrations/TISolidworks/TISolidworks';
// import SoftwareDevelopmentPage from './component/Solutions/SoftwareDevelopment/SoftwareDevelopmentPage';
// import SupportAndConsultingPage from './component/Solutions/SupportAndConsulting/SupportAndConsultingPage';
// import SharePointAndInsightPDMImplementationPage from './component/Solutions/SharePointAndInsightPDMImplementation/SharePointAndInsightPDMImplementationPage';
// import RedifiningPLMSolutionPage from './component/Solutions/RedifiningPLMSolution/RedifiningPLMSolutionPage';
// import TeamCenterIntegrationNX from './component/PLMImplementation/MCADIntegration/Integrations/TINX/TeamCenterIntegrationNX';
// import TeamcenterAWClientPage from './component/PLMImplementation/TeamcenterAWClient/TeamcenterAWClientPage';
// import PolarianALMSolutionPage from './component/Solutions/PolarianALMSolution/PolarianALMSolutionPage';
// import ProductSalePage from './pages/ProductSalesPage/ProductSalePage';
// import TeamCenterIntegrationAutocad from './component/PLMImplementation/MCADIntegration/Integrations/TIAutocad/TeamCenterIntegrationAutocad';
// import TeamCenterIntegrationSolidEdge from './component/PLMImplementation/MCADIntegration/Integrations/TISolidEdge/TeamCenterIntegrationSolidEdge';
// import Blog from './component/Blogs/Blog';
// import AuditManagement from './component/Blogs/AuditManagement';
// import RemoteCache from './component/Blogs/RemoteCache';
// import LogicalObjectPost from './component/Blogs/LogicalObject/LogicalObjectPost';
// import OpcenterPage from './component/Solutions/Opcenter/OpcenterPage';
// import FeedbackForm from './component/Home/testimonials/FeedbackForm';
// import TestimonialsSection from './component/Home/testimonials/TestimonialSection';
// import AntiCopy from './component/AntiCopy/AntiCopy';



// const App = () => {
//   const [token, setToken] = useState(localStorage.getItem('token'));
 
//   const saveToken = (userToken) => {
//       localStorage.setItem('token', userToken);
//       setToken(userToken);
//   };


//   return (
//     <Router>
//       <ScrollToTop />
//        {/* Admin panel */}
//         {/* <AntiCopy /> this is for restricting all users to copy our site data  */}
//       <Navbar />
     
//       <div>
//         <Routes>
//           {/* Home page route */}
//           <Route path="/" element={<HomePage />} />

//           {/* About us page route */}
//           <Route path="/about" element={<AboutUsPage/>} />
//           <Route path="/about/board-of-directors/sandip-dalvi" element={<SandipDalvi/>} />
//           <Route path="/about/board-of-directors/Akshay-Kothe" element={<AkshayKothe/>} />
//           <Route path="/about/board-of-directors/Nicolas-Marais" element={<NicolasMarais/>} />

//           {/* Contact us page route */}
//           <Route path="/contact" element={<ContactUsPage/>} />
         
         
//              {/* Feedback and Testimonials Routes */}
//           <Route path="/testimonials" element={<TestimonialsSection />} />
//           <Route path="/feedback" element={<FeedbackForm />} />
          
//           {/* <Route path="/teamcenter/implementation" element={<Implementation />} />
// <Route path="/teamcenter/mcad-integration" element={<MCADIntegration />} /> */}

//           {/* PLM Implementation page route */}
//           <Route path="/teamcenter-business-process-management" element={<SolutionsPage/>} />
//           <Route path="/teamcenter/plm-document-management" element={<DocumentManagement/>} />
//           <Route path="/teamcenter/bom-management" element={<ProductBOM/>} />
//           <Route path="/teamcenter/program-project-management" element={<ProgramAndProjectManagement/>} />
//           <Route path="/teamcenter/reporting-analytics" element={<ReportingandAnalytics/>} />
//           <Route path="/teamcenter/cloud-implementation" element={<TCIOnCloud/>} />
//           <Route path="/teamcenter/performance-tuning-health-checkup" element={<TCPerformance/>} />
//           <Route path="/teamcenter/cybersecurity" element={<TeamCenterCyberSecurity/>} />
//           <Route path="/teamcenter/community-collaboration" element={<TeamcenterCommunityCollaboration/>} />
//           <Route path="/teamcenter/implementation" element={<TeamcenterImplementation/>} />
//           <Route path="/teamcenter/cae-integration" element={<TeamcenterIntegrationforCAE/>} />
//           <Route path="/teamcenter/cam-integration" element={<TeamcenterIntegrationforCAM/>} />
//           <Route path='/teamcenter/rac-to-aw-client-transition' element={<TeamcenterRAC/>} />
//           <Route path="/teamcenter/upgrade-migration" element={<TeamcenterUpgradeMigration/>} />
//           <Route path="/teamcenter/plm-erp-data-process-management" element={<PLMERPDataAndProcessManagement/>} />
//           <Route path="/teamcenter/manufacturing-data-process-management" element={<ManufacturingDataAndProcessManagement/>} />
//           <Route path="/teamcenter/legacy-pdm-management" element={<LegacyPDM/>} />
//           <Route path="/teamcenter/aw-client" element={<TeamcenterAWClientPage/>} />
//           <Route path="/teamcenter/ecad-integration" element={<ECADIntegration/>} />
//           <Route path="/teamcenter/mcad-integration" element={<MCADIntegration/>} />
//           <Route path="/teamcenter/mcad-integration/catia-integration" element={<TeamCenterIntegrationCatia/>} />
//           <Route path="/teamcenter/mcad-integration/pro-engineer-integration" element={<TIProEngineer/>} />
//           <Route path="/teamcenter/mcad-integration/solidwork-integration" element={<TISolidworks/>} />
//           <Route path="/teamcenter/mcad-integration/nx-integration" element={<TeamCenterIntegrationNX/>} />
//           <Route path="/teamcenter/mcad-integration/autocad-integration" element={<TeamCenterIntegrationAutocad/>} />
//           <Route path="/teamcenter/solidedge-integration" element={<TeamCenterIntegrationSolidEdge/>} />

//           {/* SolutionsPage route */}
//           <Route path="/sharepoint-insight-pdm-implementation" element={<SharePointAndInsightPDMImplementationPage/>} />
//           <Route path="/teamcenter-software-development-services" element={<SoftwareDevelopmentPage/>} />
//           <Route path="/teamcenter-support-consulting-services" element={<SupportAndConsultingPage/>} />
//           <Route path="/mendix-apps-solutions" element={<MendixPage/>} />
//           <Route path="/teamcenter-staff-augmentation-services" element={<StaffAugmentationPage/>} />
//           <Route path="/teamcenter-plm-solutions-amc" element={<PLMSolutionsAMCPage/>} />
//           <Route path="/teamcenter-redefining-plm-solution" element={<RedifiningPLMSolutionPage/>} />
//           <Route path="/polarion-alm-solution" element={<PolarianALMSolutionPage/>} />
//           <Route path="/Opcenter" element={<OpcenterPage/>} />


//           <Route path="/product-sales" element={<ProductSalePage/>} />


//           {/* Career page route */}
//           <Route path="/career" element={<CareerPage/>} />

//           <Route path="/blog" element={<Blog/>} />
//           <Route path="/blog/audit-management" element={<AuditManagement/>} />
//           <Route path="/blog/Configure-Store-and-Forward" element={<RemoteCache/>} />
//           <Route path="/blog/Logical-object-post" element={<LogicalObjectPost/>} />

//           {/* <Route path="/login" element={<Login setToken={saveToken} />} />
//                     <Route path="/register" element={<Register />} />
//                     <Route path="/dashboard" element={<Dashboard />} />
//                     <Route path="/users" element={<Users token={token} />} />*/}
//         </Routes> 
     
//       </div>
//       <Footer />
     
//     </Router>
//   );
// };

// export default App;
// App.js


import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Footer from "./component/Home/footer/Footer";
import Navbar from "./component/Home/Navbar/Navbar";
import HomePage from "./pages/HomePage/HomePage";
import ContactUsPage from "./pages/ContactUsPage/ContactUsPage";
import AboutUsPage from "./pages/AboutusPage/AboutUsPage";

import SolutionsPage from "./component/PLMImplementation/BusinessProcessAndChangeManagement/SolutionsPage";
import DocumentManagement from "./component/PLMImplementation/DocumentManagement/DocumentManagement";
import ProductBOM from "./component/PLMImplementation/ProductBOMAndVariabilityManagement/ProductBOM";
import ProgramAndProjectManagement from "./component/PLMImplementation/ProgramAndProjectManagement/ProgramAndProjectManagement";
import ReportingandAnalytics from "./component/PLMImplementation/ReportingandAnalytics/ReportingandAnalytics";
import TCIOnCloud from "./component/PLMImplementation/TCImpementation-OnCloud/TCIOnCloud";
import TCPerformance from "./component/PLMImplementation/TCPerformanceTuning&HeathCheck-up/TCPerformance";
import TeamCenterCyberSecurity from "./component/PLMImplementation/TeamcenterCybersecurity/TeamCenterCyberSecurity";
import TeamcenterCommunityCollaboration from "./component/PLMImplementation/TeamcenterCommunityCollaboration/TeamcenterCommunityCollaboration";
import TeamcenterImplementation from "./component/PLMImplementation/TeamcenterImplementation/TeamcenterImplementation";
import TeamcenterIntegrationforCAE from "./component/PLMImplementation/TeamcenterIntegrationforCAE/TeamcenterIntegrationforCAE";
import TeamcenterIntegrationforCAM from "./component/PLMImplementation/TeamcenterIntegrationforCAM/TeamcenterIntegrationforCAM";
import TeamcenterRAC from "./component/PLMImplementation/TeamcenterRAC/TeamcenterRAC";
import TeamcenterUpgradeMigration from "./component/PLMImplementation/TeamcenterUpgrade&Migration/TeamcenterUpgradeMigration";
import PLMERPDataAndProcessManagement from "./component/PLMImplementation/PLM-ERPDataAndProcessManagement/PLMERPDataAndProcessManagement";
import ManufacturingDataAndProcessManagement from "./component/PLMImplementation/ManufacturingDataAndProcessManagement/ManufacturingDataAndProcessManagement";
import LegacyPDM from "./component/PLMImplementation/LegacyPDM/LegacyPDM";
import TeamcenterAWClientPage from "./component/PLMImplementation/TeamcenterAWClient/TeamcenterAWClientPage";
import ECADIntegration from "./component/PLMImplementation/ECADIntegration/ECADIntegration";
import MCADIntegration from "./component/PLMImplementation/MCADIntegration/MCADIntegration";
import TeamCenterIntegrationCatia from "./component/PLMImplementation/MCADIntegration/Integrations/TICatia/TeamCenterIntegrationCatia";
import TIProEngineer from "./component/PLMImplementation/MCADIntegration/Integrations/TIProEngineer/TIProEngineer";
import TISolidworks from "./component/PLMImplementation/MCADIntegration/Integrations/TISolidworks/TISolidworks";
import TeamCenterIntegrationNX from "./component/PLMImplementation/MCADIntegration/Integrations/TINX/TeamCenterIntegrationNX";
import TeamCenterIntegrationAutocad from "./component/PLMImplementation/MCADIntegration/Integrations/TIAutocad/TeamCenterIntegrationAutocad";
import TeamCenterIntegrationSolidEdge from "./component/PLMImplementation/MCADIntegration/Integrations/TISolidEdge/TeamCenterIntegrationSolidEdge";

import ScrollToTop from "./component/ScrollToTop/ScrollToTop";

import SandipDalvi from "./component/AboutUs/OurTeams/BoardMemberCard/SandipDalvi";
import AkshayKothe from "./component/AboutUs/OurTeams/BoardMemberCard/AkshayKothe";
import NicolasMarais from "./component/AboutUs/OurTeams/BoardMemberCard/NicolasMarais";

import CareerPage from "./pages/CareerPage/CareerPage";

import MendixPage from "./component/Solutions/Mendix/MendixPage";
import StaffAugmentationPage from "./component/Solutions/StaffAugmentation/StaffAugmentationPage";
import PLMSolutionsAMCPage from "./component/Solutions/PLMSolutionsAMC/PLMSolutionsAMCPage";
import SoftwareDevelopmentPage from "./component/Solutions/SoftwareDevelopment/SoftwareDevelopmentPage";
import SupportAndConsultingPage from "./component/Solutions/SupportAndConsulting/SupportAndConsultingPage";
import SharePointAndInsightPDMImplementationPage from "./component/Solutions/SharePointAndInsightPDMImplementation/SharePointAndInsightPDMImplementationPage";
import RedifiningPLMSolutionPage from "./component/Solutions/RedifiningPLMSolution/RedifiningPLMSolutionPage";
import OpcenterPage from "./component/Solutions/Opcenter/OpcenterPage";
import PolarianALMSolutionPage from "./component/Solutions/PolarianALMSolution/PolarianALMSolutionPage";

import ProductSalePage from "./pages/ProductSalesPage/ProductSalePage";

import Blog from "./component/Blogs/Blog";
import AuditManagement from "./component/Blogs/AuditManagement";
import RemoteCache from "./component/Blogs/RemoteCache";
import LogicalObjectPost from "./component/Blogs/LogicalObject/LogicalObjectPost";

import FeedbackForm from "./component/Home/testimonials/FeedbackForm";
import TestimonialsSection from "./component/Home/testimonials/TestimonialSection";

import AntiCopy from "./component/AntiCopy/AntiCopy";

const App = () => {
  const [token, setToken] = useState(localStorage.getItem("token"));

  const saveToken = (userToken) => {
    localStorage.setItem("token", userToken);
    setToken(userToken);
  };

  return (
    <Router>
      {/* Handles scroll-to-top on every route change */}
      <ScrollToTop />

      {/* Optional copy-protection */}
      {/* <AntiCopy /> */}

      <Navbar />

      <Routes>
        {/* Home */}
        <Route path="/" element={<HomePage />} />

        {/* About */}
        <Route path="/about" element={<AboutUsPage />} />
        <Route
          path="/about/board-of-directors/sandip-dalvi"
          element={<SandipDalvi />}
        />
        <Route
          path="/about/board-of-directors/Akshay-Kothe"
          element={<AkshayKothe />}
        />
        <Route
          path="/about/board-of-directors/Nicolas-Marais"
          element={<NicolasMarais />}
        />

        {/* Contact */}
        <Route path="/contact" element={<ContactUsPage />} />

        {/* Feedback & Testimonials */}
        <Route path="/testimonials" element={<TestimonialsSection />} />
        <Route path="/feedback" element={<FeedbackForm />} />

        {/* PLM Implementation */}
        <Route
          path="/teamcenter-business-process-management"
          element={<SolutionsPage />}
        />
        <Route
          path="/teamcenter-plm-document-management"
          element={<DocumentManagement />}
        />
        <Route path="/teamcenter-bom-management" element={<ProductBOM />} />
        <Route
          path="/teamcenter-program-project-management"
          element={<ProgramAndProjectManagement />}
        />
        <Route
          path="/teamcenter-reporting-analytics"
          element={<ReportingandAnalytics />}
        />
        <Route
          path="/teamcenter-cloud-implementation"
          element={<TCIOnCloud />}
        />
        <Route
          path="/teamcenter-performance-tuning-health-checkup"
          element={<TCPerformance />}
        />
        <Route
          path="/teamcenter-cybersecurity"
          element={<TeamCenterCyberSecurity />}
        />
        <Route
          path="/teamcenter-community-collaboration"
          element={<TeamcenterCommunityCollaboration />}
        />
        <Route
          path="/teamcenter-implementation"
          element={<TeamcenterImplementation />}
        />
        <Route
          path="/teamcenter-cae-integration"
          element={<TeamcenterIntegrationforCAE />}
        />
        <Route
          path="/teamcenter-cam-integration"
          element={<TeamcenterIntegrationforCAM />}
        />
        <Route
          path="/teamcenter-rac-to-aw-client-transition"
          element={<TeamcenterRAC />}
        />
        <Route
          path="/teamcenter-upgrade-migration"
          element={<TeamcenterUpgradeMigration />}
        />
        <Route
          path="/teamcenter-plm-erp-data-process-management"
          element={<PLMERPDataAndProcessManagement />}
        />
        <Route
          path="/teamcenter-manufacturing-data-process-management"
          element={<ManufacturingDataAndProcessManagement />}
        />
        <Route
          path="/teamcenter-legacy-pdm-management"
          element={<LegacyPDM />}
        />
        <Route
          path="/teamcenter-aw-client"
          element={<TeamcenterAWClientPage />}
        />
        <Route
          path="/teamcenter-ecad-integration"
          element={<ECADIntegration />}
        />
        <Route
          path="/teamcenter-mcad-integration"
          element={<MCADIntegration />}
        />

        {/* Deep MCAD detail routes */}
        <Route
          path="/teamcenter/mcad-integration/catia-integration"
          element={<TeamCenterIntegrationCatia />}
        />
        <Route
          path="/teamcenter/mcad-integration/pro-engineer-integration"
          element={<TIProEngineer />}
        />
        <Route
          path="/teamcenter/mcad-integration/solidwork-integration"
          element={<TISolidworks />}
        />
        <Route
          path="/teamcenter/mcad-integration/nx-integration"
          element={<TeamCenterIntegrationNX />}
        />
        <Route
          path="/teamcenter/mcad-integration/autocad-integration"
          element={<TeamCenterIntegrationAutocad />}
        />
        <Route
          path="/teamcenter-solidedge-integration"
          element={<TeamCenterIntegrationSolidEdge />}
        />

        {/* Solutions */}
        <Route
          path="/sharepoint-insight-pdm-implementation"
          element={<SharePointAndInsightPDMImplementationPage />}
        />
        <Route
          path="/teamcenter-software-development-services"
          element={<SoftwareDevelopmentPage />}
        />
        <Route
          path="/teamcenter-support-consulting-services"
          element={<SupportAndConsultingPage />}
        />
        <Route path="/mendix-apps-solutions" element={<MendixPage />} />
        <Route
          path="/teamcenter-staff-augmentation-services"
          element={<StaffAugmentationPage />}
        />
        <Route
          path="/teamcenter-plm-solutions-amc"
          element={<PLMSolutionsAMCPage />}
        />
        <Route
          path="/teamcenter-redefining-plm-solution"
          element={<RedifiningPLMSolutionPage />}
        />
        <Route
          path="/polarion-alm-solution"
          element={<PolarianALMSolutionPage />}
        />
        <Route path="/Opcenter" element={<OpcenterPage />} />

        {/* Product Sales */}
        <Route path="/product-sales" element={<ProductSalePage />} />

        {/* Career */}
        <Route path="/career" element={<CareerPage />} />

        {/* Blogs */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/audit-management" element={<AuditManagement />} />
        <Route
          path="/blog/Configure-Store-and-Forward"
          element={<RemoteCache />}
        />
        <Route
          path="/blog/Logical-object-post"
          element={<LogicalObjectPost />}
        />

        {/* Auth routes (currently disabled) */}
        {/* 
        <Route path="/login" element={<Login setToken={saveToken} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users" element={<Users token={token} />} />
        */}
      </Routes>

      <Footer />
    </Router>
  );
};

export default App;
